import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { HTMLViewerComponent } from './timeline/lessons/html/html-viewer.component';

const routes: Routes = [
  { path: 'logout', redirectTo: 'login/logout', pathMatch: 'full' },
  { path: '', loadChildren: () => import('./timeline/timeline.module').then(x => x.TimelineModule) },
  { path: 'login', loadChildren: () => import('./auth/auth.module').then(x => x.AuthModule) },
  { path: 'cadastro', loadChildren: () => import('./registration/registration.module').then(x => x.RegistrationModule) },
  { path: 'atividades', loadChildren: () => import('./activities/activities.module').then(x => x.ActivitiesModule) },
  { path: 'comunidade', loadChildren: () => import('./social/social.module').then(x => x.SocialModule) },
  { path: 'perfil', loadChildren: () => import('./profile/profile.module').then(x => x.ProfileModule) },
  { path: 'menuitem/:id', component: HTMLViewerComponent },
  { path: 'shared', loadChildren: () => import('./shared/shared.module').then(m => m.SharedModule) },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];

const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
